module.exports = __webpack_public_path__ + "img/precious_plastic_creations.34f9d690.png";